import * as React from 'react';

import { IconProps } from '../Icon';

export const ForecastReportOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    id="Layer_1"
    version="1.1"
    viewBox="0 0 512 512"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M414,28.055h-56.325C342.812,10.889,320.908,0,296.5,0h-81c-24.408,0-46.312,10.889-61.175,28.055H98   c-24.813,0-45,20.227-45,45.088v393.769C53,491.773,73.187,512,98,512h316c24.813,0,45-20.227,45-45.088V73.143   C459,48.281,438.813,28.055,414,28.055z M215.5,30.059h81c23.177,0,42.425,15.515,48.75,36.07H166.75   C173.064,45.61,192.287,30.059,215.5,30.059z M429,466.912c0,8.287-6.729,15.029-15,15.029H98c-8.271,0-15-6.742-15-15.029V73.143   c0-8.287,6.729-15.029,15-15.029h39.846c-2.165,7.31-3.346,15.04-3.346,23.045c0,8.3,6.716,15.029,15,15.029h213   c8.284,0,15-6.729,15-15.029c0-8.005-1.181-15.735-3.346-23.045H414c8.271,0,15,6.742,15,15.029V466.912z" />
      <path d="M182.06,298.644L160,320.746l-5.394-5.404c-5.857-5.87-15.355-5.87-21.213,0c-5.858,5.869-5.858,15.385,0,21.254l16,16.031   c5.857,5.869,15.355,5.87,21.213,0l32.666-32.73c5.858-5.869,5.858-15.385,0-21.254   C197.415,292.774,187.917,292.774,182.06,298.644z" />
      <path d="M367,310.607H246c-8.284,0-15,6.729-15,15.029c0,8.3,6.716,15.029,15,15.029h121c8.284,0,15-6.729,15-15.029   C382,317.336,375.284,310.607,367,310.607z" />
      <path d="M182.06,384.812L160,406.914l-5.394-5.404c-5.857-5.87-15.355-5.87-21.213,0c-5.858,5.869-5.858,15.385,0,21.254l16,16.031   c5.857,5.869,15.355,5.87,21.213,0l32.666-32.73c5.858-5.869,5.858-15.385,0-21.254   C197.415,378.942,187.917,378.942,182.06,384.812z" />
      <path d="M367,396.775H246c-8.284,0-15,6.729-15,15.029c0,8.3,6.716,15.029,15,15.029h121c8.284,0,15-6.729,15-15.029   C382,403.504,375.284,396.775,367,396.775z" />
      <path d="M284.606,241.077L331,194.593v1.791c0,8.3,6.716,15.029,15,15.029s15-6.729,15-15.029c0-42.513,0.07-38.555-0.172-40.234   c-1.061-7.353-7.353-12.872-14.833-12.87H308c-8.284,0-15,6.729-15,15.029c0,8.3,6.716,15.029,15,15.029h1.787L274,209.195   l-45.394-45.482c-5.857-5.87-15.355-5.87-21.213,0l-54,54.106c-5.858,5.869-5.858,15.385,0,21.254c5.857,5.87,15.355,5.87,21.213,0   L218,195.595l45.394,45.482C269.25,246.946,278.749,246.947,284.606,241.077z" />
    </g>
  </svg>
);
